// extracted by mini-css-extract-plugin
export default {"Overlay":"select-panel-editor-module__Overlay--iX4sQ"};